<template>
  <TabBar activeTabName="alerts" />
  <RecentAlertList />
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import RecentAlertList from '@/components/notifications/RecentAlertList.vue'
import TabBar from '@/components/notifications/TabBar.vue'

@Options({
  components: {
    RecentAlertList,
    TabBar
  }
})
export default class NotificationsHome extends Vue {
}
</script>
